import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { Grid } from "@mui/material";
import { AnalyticsSpacing } from "consts";
import AnalyticsCardGroup from "features/analytics/components/AnalyticsCardGroup";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import { useMetricName } from "features/analytics/hooks/useMetricName";
import { CHART_KEY_CHANNEL_INSIGHTS_TRAFFIC_PERFORMANCE_TABLE } from "features/analytics/constants/chartKeys";
import AnalyticsCard from "features/analytics/components/AnalyticsCard";
import { table10Rows } from "features/analytics";

function ChannelInsights() {
  const metricToName = useMetricName();

  return (
    <Grid
      container
      spacing={AnalyticsSpacing}
      mb={4}
      direction="column"
      sx={{ height: "100%", gap: AnalyticsSpacing }}
    >
      <Grid>
        <AnalyticsCardGroup
          title={(metric) => `Top 5 Channels by ${metricToName(metric)}`}
          metrics={[
            ApiMetric.METRIC_SESSIONS_COUNT,
            ApiMetric.METRIC_PAGEVIEWS_COUNT,
            ApiMetric.METRIC_EFFECTIVE_SESSIONS_COUNT,
            ApiMetric.METRIC_EFFECTIVE_PAGEVIEWS_COUNT,
            ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
            ApiMetric.METRIC_MACRO_CONVERSION_RATE,
            ApiMetric.METRIC_REVENUE,
          ]}
          renderBody={(metric) => (
            <Grid container sx={{ height: 430 }} spacing={AnalyticsSpacing}>
              <Grid item xs={8}>
                <AnalyticsCard
                  chart={{
                    name: ``,
                    dimension: [
                      ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                      ApiDimension.DIMENSION_CHANNEL,
                    ],
                    template: ApiChartTemplate.TREND,
                    type: ApiChartType.GRAPH,
                    attributes: [],
                    limit: 5,
                    yAxisKeys: [
                      {
                        key: "l",
                        fields: [metric],
                      },
                    ],
                    displayOptions: {
                      noFilters: true,
                      noTitle: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <AnalyticsCard
                  chart={{
                    name: ``,
                    dimension: [ApiDimension.DIMENSION_CHANNEL],
                    template: ApiChartTemplate.SNAPSHOT,
                    type: ApiChartType.PIE,
                    attributes: [],
                    limit: 5,
                    yAxisKeys: [
                      {
                        key: "l",
                        fields: [metric],
                      },
                    ],
                    displayOptions: {
                      noFilters: true,
                      showTotals: true,
                      noTitle: true,
                    },
                  }}
                />
              </Grid>
            </Grid>
          )}
        />
      </Grid>

      <Grid sx={{ flexGrow: 1, minHeight: table10Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_CHANNEL_INSIGHTS_TRAFFIC_PERFORMANCE_TABLE}
          chart={{
            name: "Traffic & Performance by ",
            dimension: [ApiDimension.DIMENSION_CHANNEL],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: [],
            comparison: true,
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_LEADS_COUNT,
                  ApiMetric.METRIC_RETURNING_LEAD_PERCENTAGE,
                  ApiMetric.METRIC_AVERAGE_PAGEVIEWS_PER_SESSION,
                  ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE_DURING_SESSION,
                  ApiMetric.METRIC_SESSION_ADD_TO_CART_CLICK_RATE,
                  ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
                  ApiMetric.METRIC_REVENUE,
                ],
              },
            ],
            displayOptions: {
              noAttributionToggle: true,
              rowsPerPage: 0,
              availableDimensions: [
                ApiDimension.DIMENSION_CHANNEL,
                ApiDimension.DIMENSION_SOURCE,
                ApiDimension.DIMENSION_MEDIUM,
                ApiDimension.DIMENSION_CAMPAIGN,
                ApiDimension.DIMENSION_CONTENT,
                ApiDimension.DIMENSION_TERM,
              ],
            },
          }}
        />
      </Grid>
    </Grid>
  );
}

export default ChannelInsights;
